import React, { useState, useEffect } from 'react';
import '../../App.css';
import MainBackground from '../../images/MainBackground.jpg';

const Testimonials = () => {
    const [currentGroup, setCurrentGroup] = useState(0);
    const [activeCardIndex, setActiveCardIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isTablet, setIsTablet] = useState(window.innerWidth <= 1024 && window.innerWidth > 768);

    const testimonialGroups = [
        // Group 1
        [
            {
                quote: "UrVOTE is the first thing we've seen this century that moves us one vital step closer to democracy.",
                name: "Rik Schnabel",
                title: "Australia's Brain Untrainer",
                // image: "/path/to/rik-image.jpg"
            },
            {
                quote: "As an economist, I value the link between academic research and political decision-making. UrVote translates complex economic insights into accessible information for voters, bridging the gap between scholarship and policy to help citizens make informed choices and strengthen democracy.",
                name: "Alejandro Pacheco",
                title: "Lecturer, Tecnológico de Monterrey",
                // image: "/path/to/alejandro-image.jpg"
            },
            {
                quote: "Having stood at the federal, state, and local levels, I have seen how disconnected voters can feel—and how little changes when the same decisions are made behind closed doors. UrVote offers a smarter way forward. Voting the same gets us the same—this platform gives people the tools to demand better.",
                name: "Alexander (Anthony) Ansalone",
                title: "Former Federal, State & Local Candidate",
                // image: "/path/to/alexander-image.jpg"
            }
        ],
        // Group 2
        [
            {
                quote: "UrVote provides a wealth of knowledge on the policies and platforms that affect the everyday voter, allowing them to be better informed. It provides an unbiased and succinct viewpoint, allowing the casual or serious user to make informed decisions about who to vote for.",
                name: "Scott McCamish",
                title: "Electorate Officer",
                // image: "/path/to/scott-image.jpg"
            },
            {
                quote: "UrVote has given me my voice back to allow me to uncover secret agendas, vote for or against policies that best serve my family and community.",
                name: "Mary Costallos",
                title: "Founder and CEO of Buskpal",
                // image: "/path/to/mary-image.jpg"
            },
            {
                quote: "Urvote makes it easy to understand where candidates stand and how their votes affect our lives. It's an empowering, accessible way to engage with Australian democracy.",
                name: "Ian Woodhouse",
                title: "Business Coach at ProfitPoint Business Solution",
                // image: "/path/to/ian-image.jpg"
            }
        ]
        /* Commenting out additional groups
        // Group 3
        [
            {
                quote: "Making informed voting decisions has never been easier thanks to this platform.",
                name: "David Wilson",
                title: "Teacher",
                // image: "/path/to/david-image.jpg"
            },
            {
                quote: "The detailed information about candidates helps me make better choices.",
                name: "Lisa Anderson",
                title: "Student",
                // image: "/path/to/lisa-image.jpg"
            },
            {
                quote: "A game-changer for democratic participation and voter education.",
                name: "James Taylor",
                title: "Civic Activist",
                // image: "/path/to/james-image.jpg"
            }
        ],
        // Group 4
        [
            {
                quote: "The platform's user-friendly interface makes it accessible to everyone.",
                name: "Rachel Brown",
                title: "Tech Consultant",
                // image: "/path/to/rachel-image.jpg"
            },
            {
                quote: "Finally, a solution that makes voting information clear and accessible.",
                name: "Thomas Lee",
                title: "Business Owner",
                // image: "/path/to/thomas-image.jpg"
            },
            {
                quote: "This has transformed how I engage with the democratic process.",
                name: "Maria Garcia",
                title: "Community Organizer",
                // image: "/path/to/maria-image.jpg"
            }
        ],
        // Group 5
        [
            {
                quote: "An essential tool for any informed voter in today's democracy.",
                name: "Kevin Martinez",
                title: "Policy Analyst",
                // image: "/path/to/kevin-image.jpg"
            },
            {
                quote: "The platform's commitment to transparency is commendable.",
                name: "Amanda White",
                title: "Journalist",
                // image: "/path/to/amanda-image.jpg"
            },
            {
                quote: "This is exactly what modern democracy needs.",
                name: "Robert King",
                title: "Professor",
                // image: "/path/to/robert-image.jpg"
            }
        ]
        */
    ];

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setIsTablet(window.innerWidth <= 1024 && window.innerWidth > 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Auto-scroll functionality
    useEffect(() => {
        const scrollInterval = setInterval(() => {
            if (isMobile || isTablet) {
                setCurrentGroup((prevGroup) => {
                    const totalCards = testimonialGroups.reduce((acc, group) => acc + group.length, 0);
                    const currentCard = (prevGroup * 3) + activeCardIndex;
                    const nextCard = currentCard + 1;
                    
                    if (nextCard >= totalCards) {
                        setActiveCardIndex(0);
                        return 0;
                    }
                    
                    if (nextCard % 3 === 0) {
                        setActiveCardIndex(0);
                        return prevGroup + 1;
                    }
                    
                    setActiveCardIndex(activeCardIndex + 1);
                    return prevGroup;
                });
            } else {
                setCurrentGroup((prevGroup) => {
                    const nextGroup = prevGroup >= testimonialGroups.length - 1 ? 0 : prevGroup + 1;
                    setActiveCardIndex(0);
                    return nextGroup;
                });
            }
        }, 6000);

        return () => clearInterval(scrollInterval);
    }, [isMobile, isTablet, activeCardIndex]);

    // Get all cards in a flat array for mobile view
    const getAllCards = () => {
        return testimonialGroups.reduce((acc, group) => [...acc, ...group], []).filter(Boolean);
    };

    return (
        <div className="testimonials-container" style={{
            backgroundImage: `url(${MainBackground})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '0'
        }}>
            <div style={{
                width: "100%",
                maxWidth: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                borderRadius: "0",
                padding: '0',
                position: "relative",
                minHeight: isMobile || isTablet ? "100vh" : "100vh",
                boxSizing: "border-box",
                margin: '0',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div className="testimonials-header" style={{
                    marginBottom: isMobile ? '20px' : '50px',
                    textAlign: 'center',
                    paddingTop: isMobile ? '40px' : '100px',
                    position: 'relative',
                    zIndex: 2
                }}>
                    <h2 style={{
                        fontSize: '32px',
                        fontWeight: 'bold',
                        color: '#ffffff',
                        marginBottom: isMobile ? '10px' : '15px',
                        paddingTop: '20px'
                    }}>Testimonials</h2>
                </div>

                <div className="testimonials-slider" style={{
                    width: '100%',
                    maxWidth: isMobile ? '95%' : isTablet ? '600px' : '1600px',
                    margin: '0 auto',
                    padding: isMobile ? '0' : '10px',
                    position: 'relative',
                    zIndex: 2,
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: isMobile ? 'auto' : '80vh'
                }}>
                    <div className="testimonials-group" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: isMobile || isTablet ? '20px' : '40px',
                        flexWrap: 'nowrap',
                        marginBottom: isMobile ? '10px' : '30px',
                        height: isMobile || isTablet ? 'auto' : '500px',
                        flexDirection: isMobile || isTablet ? 'column' : 'row',
                        width: isMobile ? '95%' : '100%',
                        margin: '0 auto'
                    }}>
                        {(isMobile || isTablet ? 
                            [getAllCards()[currentGroup * 3 + activeCardIndex]] : 
                            testimonialGroups[currentGroup]
                        )?.map((testimonial, index) => (
                            testimonial && (
                                <div key={index} style={{
                                    position: 'relative',
                                    width: isMobile ? '100%' : isTablet ? '100%' : '480px',
                                    height: '400px',
                                    marginTop: '10px',
                                    opacity: 1,
                                    transform: 'translateX(0)',
                                    transition: 'all 1s ease-in-out',
                                    boxSizing: 'border-box'
                                }}>
                                    <div className="testimonial-profile" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        position: 'absolute',
                                        top: '10px',
                                        left: '30px',
                                        zIndex: 2
                                    }}>
                                        {/* Commenting out the image element
                                        <img 
                                            src={testimonial.image} 
                                            alt={testimonial.name}
                                            style={{
                                                width: '80px',
                                                height: '80px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '4px solid #f3f3f3'
                                            }}
                                        />
                                        */}
                                        <div style={{
                                            textAlign: 'left'
                                        }}>
                                            <h3 style={{
                                                fontSize: '20px',
                                                color: '#1a365d',
                                                marginBottom: '5px',
                                                fontWeight: '600'
                                            }}>{testimonial.name}</h3>
                                            <h4 style={{
                                                fontSize: '14px',
                                                color: '#777777',
                                                fontWeight: '400',
                                                margin: 0
                                            }}>{testimonial.title}</h4>
                                        </div>
                                    </div>

                                    <div className="testimonial-item" style={{
                                        width: '100%',
                                        height: '370px',
                                        background: 'white',
                                        padding: isMobile ? '20px' : '40px',
                                        borderRadius: '8px',
                                        boxShadow: '0 2px 15px rgba(0, 0, 0, 0.1)',
                                        position: 'absolute',
                                        bottom: '0',
                                        left: '0',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        boxSizing: 'border-box'
                                    }}>
                                        <div style={{ flex: 1 }}>
                                            <div className="quote-icon" style={{
                                                fontSize: '48px',
                                                color: '#007fff',
                                                marginBottom: '0',
                                                opacity: '1',
                                                position: 'absolute',
                                                top: '80px',
                                                left: '20px'
                                            }}>❝</div>
                                            <p className="quote" style={{
                                                fontSize: '16px',
                                                color: '#444444',
                                                lineHeight: '1.8',
                                                marginBottom: '20px',
                                                fontStyle: 'italic',
                                                height: 'auto',
                                                marginTop: '100px',
                                                marginLeft: '20px',
                                                marginRight: '20px'
                                            }}>
                                                {testimonial.quote}
                                            </p>
                                            <div style={{
                                                fontSize: '48px',
                                                color: '#007fff',
                                                opacity: '1',
                                                position: 'absolute',
                                                bottom: '20px',
                                                right: '20px'
                                            }}>❞</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}
                    </div>

                    <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '8px',
                        position: 'fixed',
                        bottom: '80px',
                        left: '0',
                        right: '0',
                        zIndex: 1000
                    }}>
                        {(isMobile || isTablet ? 
                            Array.from({ length: getAllCards().length }) : 
                            testimonialGroups
                        ).map((_, index) => (
                            <button
                                key={index}
                                className={`dot ${
                                    isMobile || isTablet ? 
                                    (currentGroup * 3 + activeCardIndex === index) : 
                                    (currentGroup === index) ? 'active' : ''
                                }`}
                                onClick={() => {
                                    if (isMobile || isTablet) {
                                        setCurrentGroup(Math.floor(index / 3));
                                        setActiveCardIndex(index % 3);
                                    } else {
                                        setCurrentGroup(index);
                                        setActiveCardIndex(0);
                                    }
                                }}
                                style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    border: 'none',
                                    backgroundColor: isMobile || isTablet ? 
                                        (currentGroup * 3 + activeCardIndex === index ? '#00bfff' : '#cbd6e9') :
                                        (currentGroup === index ? '#00bfff' : '#cbd6e9'),
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    padding: 0,
                                    margin: '0 4px',
                                    opacity: 0.7,
                                    transform: (isMobile || isTablet) ? 
                                        (currentGroup * 3 + activeCardIndex === index ? 'scale(1.2)' : 'scale(1)') :
                                        (currentGroup === index ? 'scale(1.2)' : 'scale(1)')
                                }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
